import { useMemo } from 'react';
import { Button } from '../ui/button';

// Local-date formatting on purpose: toISOString() is UTC, so between midnight
// and 02:00 SAST it returns YESTERDAY and every default range lands a day out.
export const fmtLocal = (d) =>
  `${d.getFullYear()}-${String(d.getMonth() + 1).padStart(2, '0')}-${String(d.getDate()).padStart(2, '0')}`;

export const buildPresets = () => {
  const now = new Date();
  const y = now.getFullYear();
  const m = now.getMonth();
  const minus = (n) => { const d = new Date(); d.setDate(d.getDate() - n); return d; };
  return [
    { key: 'this_month', label: 'This month', start: fmtLocal(new Date(y, m, 1)), end: fmtLocal(now) },
    { key: 'last_month', label: 'Last month', start: fmtLocal(new Date(y, m - 1, 1)), end: fmtLocal(new Date(y, m, 0)) },
    { key: 'last_7', label: 'Last 7 days', start: fmtLocal(minus(7)), end: fmtLocal(now) },
    { key: 'last_30', label: 'Last 30 days', start: fmtLocal(minus(30)), end: fmtLocal(now) },
    { key: 'last_90', label: 'Last 90 days', start: fmtLocal(minus(90)), end: fmtLocal(now) },
    { key: 'ytd', label: 'Year to date', start: fmtLocal(new Date(y, 0, 1)), end: fmtLocal(now) },
  ];
};

/** Quick-pick period buttons that drive the same From/To state as the date inputs. */
export const DateRangePresets = ({ start, end, setStart, setEnd, testidPrefix = 'preset' }) => {
  const presets = useMemo(buildPresets, []);
  const matched = presets.some((p) => p.start === start && p.end === end);
  return (
    <div className="flex flex-wrap items-center gap-2" data-testid={`${testidPrefix}-bar`}>
      {presets.map((p) => {
        const active = start === p.start && end === p.end;
        return (
          <Button
            key={p.key}
            size="sm"
            variant={active ? 'default' : 'outline'}
            className={`h-7 text-xs ${active ? 'bg-[#0D5B69] hover:bg-[#0D5B69]/90 text-white border-[#0D5B69]' : ''}`}
            onClick={() => { setStart(p.start); setEnd(p.end); }}
            data-testid={`${testidPrefix}-${p.key}`}
          >
            {p.label}
          </Button>
        );
      })}
      {!matched && (
        <span
          className="h-7 px-2.5 inline-flex items-center rounded-md border border-[#80C030]/50 bg-[#80C030]/10 text-[11px] font-medium text-[#0D5B69]"
          data-testid={`${testidPrefix}-custom`}
        >
          Custom range
        </span>
      )}
    </div>
  );
};
